import { requestGet } from '@/common/request';

export interface getAuditNumberParams {}

export interface getAuditNumberRes {}

//会场运营 - 根据会场活动 id 查询详情
export async function getAuditNumber(params: getAuditNumberParams): Promise<getAuditNumberRes> {
  return await requestGet('/room/getAuditNumber', params);
}
